import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { getMarginBottomClass, marginBottomLevels } from '../../utils/marginBottom/index.js';
import styles from './button-row.css.js';

var ButtonRow = function ButtonRow(_ref) {
  var _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'right' : _ref$align,
      children = _ref.children,
      _ref$marginBottom = _ref.marginBottom,
      marginBottom = _ref$marginBottom === void 0 ? 0 : _ref$marginBottom;
  return React.createElement("ul", {
    className: cn(styles.ButtonRow, styles["align-".concat(align)], getMarginBottomClass(marginBottom))
  }, React.Children.map(children, function (child) {
    return React.createElement("li", {
      className: styles.button
    }, child);
  }));
};

ButtonRow.displayName = 'ButtonRow';
ButtonRow.propTypes = process.env.NODE_ENV !== "production" ? {
  align: PropTypes.oneOf(['left', 'right']),
  children: PropTypes.node,

  /**
   * 0, 1, 2, 3, 4, 5, 6, 7
   */
  marginBottom: PropTypes.oneOf(marginBottomLevels)
} : {};
export default ButtonRow;